import { Children, forwardRef, type Ref, type ReactNode } from 'react';
import type { BaseProps } from '../../theme/index.js';
import { useBaseAttrs, splitBaseProps } from '../../core/_internal/factory.js';
import './Breadcrumbs.css';

export interface BreadcrumbsProps extends BaseProps {
  separator?: ReactNode;
  children?: ReactNode;
}

/** Breadcrumb navigation: separated by `/` (or custom). */
export const Breadcrumbs = forwardRef(function Breadcrumbs(
  { separator = '/', children, ...rest }: BreadcrumbsProps,
  ref: Ref<HTMLElement>
): ReactNode {
  const base = useBaseAttrs('rr-breadcrumbs', rest);
  const { dom } = splitBaseProps(rest);
  const items = Children.toArray(children);
  return (
    <nav {...dom} ref={ref} aria-label="Breadcrumb" {...base.attrs} className={base.className} style={base.style}>
      <ol className="rr-breadcrumbs__list">
        {items.map((item, i) => (
          <li key={i} className="rr-breadcrumbs__item">
            {item}
            {i < items.length - 1 ? <span aria-hidden className="rr-breadcrumbs__separator">{separator}</span> : null}
          </li>
        ))}
      </ol>
    </nav>
  );
});
